//imports
import { all } from 'redux-saga/effects';

//Views
import cloudLoginPageUploadImageSagas from 'Modules/loginPage/main/.components/uploadImage/redux/saga';
import createEditTemplateSagas from 'Modules/loginPage/main/.components/createEditTemplate/redux/saga';
import loginPageMainSagas from 'Modules/loginPage/main/redux/saga';
//merge sagas
export default function* rootSaga() {
    yield all([
        cloudLoginPageUploadImageSagas(),
        createEditTemplateSagas(),
        loginPageMainSagas(),
    ]);
}